import { ANSWERS_4 } from './data/data4-answers';
import { ANSWERS_6 } from './data/data6-answers';
import { ANSWERS_7 } from './data/data7-answers';
import { ANSWERS_NL_4 } from './data/nl/answers4';
import { ANSWERS_NL_5 } from './data/nl/answers5';
import { ANSWERS_NL_6 } from './data/nl/answers6';
import { ANSWERS_NL_7 } from './data/nl/answers7';
import { DEFAULT_LANGUAGE, type Language } from './languages';
import { isSupportedLength } from './lengths';
import { ANSWERS } from './words';

/**
 * Every playable length's ANSWER list, in every language, statically —
 * and therefore in the web's main bundle by design (~31 KB of English
 * strings, ~41 KB of Dutch).
 *
 * This is the resolution of spec §10.2 vs §10.5: the weekday ladder makes
 * the daily a 4-, 6- or 7-letter puzzle, and §3.3 promises the daily is
 * derived offline at boot, so `dailyAnswer` cannot wait on a chunk. Adding
 * a language does not change that promise — a player whose language is
 * Dutch needs the Dutch answers at boot for exactly the same reason — so
 * both languages' answers are static and only the ~800 KB of accepted-GUESS
 * lists stay lazy in `wordsLazy.ts`, which is where the code-splitting
 * boundary lives. Nothing here reaches a `*-guesses`/`nl/guesses*` module.
 */
const ANSWERS_BY_LANGUAGE: Readonly<Record<Language, Readonly<Record<number, readonly string[]>>>> = {
  en: { 4: ANSWERS_4, 5: ANSWERS, 6: ANSWERS_6, 7: ANSWERS_7 },
  nl: { 4: ANSWERS_NL_4, 5: ANSWERS_NL_5, 6: ANSWERS_NL_6, 7: ANSWERS_NL_7 },
};

/**
 * Answer list for a playable length; an empty array for anything else.
 *
 * English length 5 returns the very same `ANSWERS` array the 5-letter game
 * has always used — identity, not a copy — which, together with the
 * `DEFAULT_LANGUAGE` default, is what lets `dailyAnswer` be written once
 * for every length *and* language without moving a single past answer.
 */
export function answersOfLength(
  length: number,
  language: Language = DEFAULT_LANGUAGE,
): readonly string[] {
  return isSupportedLength(length) ? ANSWERS_BY_LANGUAGE[language][length]! : [];
}
